export const STORE_USER = 'STORE_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const USER_DATA='USER_DATA';